// extracted by mini-css-extract-plugin
export default {"label":"TextArea_label__ewxUT","wrap":"TextArea_wrap__npF2T","textarea":"TextArea_textarea__dZ0pB"};